module.exports = __webpack_public_path__ + "static/media/icon-change-ingredient.9b4ad0a8.svg";